import { FiMenu } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import MainMenuDrawer from "../ui/MainMenuDrawer";
import { trackEvent } from "../../services/amplitude";
import "../../styles/MainMenuButton.css";

export default function MainMenuButton({
  chatId = "",
  open,
  onToggle,
  onClose,
}) {
  const { t } = useTranslation("common");

  return (
    <div className="mainMenuWrap">
      <button
        className="iconBtn"
        aria-label={t("menu")}
        title={t("menu")}
        onClick={(e) => {
          e.stopPropagation();

          if (!open) {
            trackEvent("main_menu_opened", {
              source: "header",
            });
          }

          onToggle?.();
        }}
      >
        <FiMenu className="iconReact" />
      </button>

      <MainMenuDrawer
        chatId={chatId}
        open={open}
        onClose={onClose}
      />
    </div>
  );
}